var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftbar-tab-menu"},[_c('IconsBar',{attrs:{"confirmViews":_vm.confirmViews},on:{"openMenu":_vm.openMenuOf}}),_c('MenuBar',{attrs:{"activeMenu":_vm.activeMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }